// extracted by mini-css-extract-plugin
module.exports = {"CLOSE_BUTTON_WIDTH":"48","closeButton":"CloseButton_closeButton__PEgpc"};